function q(n, f) {
  return n === f || n !== n && f !== f;
}
var r = q;
export {
  r as default
};
//# sourceMappingURL=eq.js.map
